import Button from "../button/Button";
import styles from "./InfoCard.module.css";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { configAction } from "../../store/config/slice";
import { ModalStep } from "../../types/config";
import Placeholder from "../placeHolder/PlaceHolder";
import { placeHolder } from "../../types/common";
import { useWebEngageTaraLoginStart } from "../../hooks/webengage";

const InfoCard = () => {
  const { trackWebEngageTaraLoginStart } = useWebEngageTaraLoginStart();
  const dispatch = useAppDispatch();
  const sendDataToGTM = useGTMDispatch();
  const { token } = useAppSelector((state) => state.config);
  const { userData } = useAppSelector((state) => state.login);
  const { wallet } = useAppSelector((state) => state.wallet);
  const hasTaraWallet = wallet.data?.data?.exist!;
  const handleLogout = function () {
    dispatch(configAction.setModalStep(ModalStep.LOGOUT));
  };
  const handleLogin = function () {
    // sendDataToGTM({ event: "GardoonebaniShans1402-StartBt" });
    dispatch(configAction.setModalStep(ModalStep.LOGIN));
    trackWebEngageTaraLoginStart();
  };
  const handleOPenSlide = function () {
    window.location.href = "https://www.banimode.com/";
  };
  return (
    <div className={styles.card}>
      <div className={styles.cardInner}>
        {token && (
          <div className={styles.login}>
            <div className={styles.loginNumber}>
              <p>
                با شماره <span>{userData?.mobile}</span> وارد شدی!
              </p>
            </div>
            <button className={styles.loginChange} onClick={handleLogout}>
              <span>تغییر شماره</span>
              <img
                src={`${process.env.PUBLIC_URL}/assets/icon/edit.svg`}
                alt=""
              />
            </button>
          </div>
        )}
        {!token && (
          <div className={styles.signIn}>
            <div className={styles.title}>
              <span>
                تا ۱۰ میلیون تومان اعتبار فوری تارا سه قسطه، ویژه خرید از
                بانی‌مد
              </span>
            </div>
            <p>
              با درخواست اعتبار سه قسطه تارا می‌تونید الان از بانی‌مد خرید کنید
              و از ابتدای ماه بعد، در سه قسط پرداخت کنید! همین الان از لینک زیر
              ۲ میلیون تومان اعتبار اولیه سه قسطه بگیرید، خرید کنید و با خوش
              حسابی در پرداخت اقساط، اعتبارتون رو تا ۱۰ میلیون تومان افزایش
              بدید.
            </p>
            <Button text="دریافت اعتبار سه قسطه" onclick={handleLogin} arrow />
          </div>
        )}
        {token && (
          <div className={styles.tara}>
            <div className={styles.taraInfo}>
              <img
                src={`${process.env.PUBLIC_URL}/assets/icon/check.svg`}
                alt=""
              />
              <p>
                ثبت نام شما برای دریافت اعتبار با موفقیت انجام شد. لینک نصب و
                دریافت اعتبار تارا برای شما بزودی ارسال می‌شود
              </p>
            </div>
            <div className="flex justify-center flex-col w-full gap-2 items-center">
              <Button text="برو به بانی مد" onclick={handleOPenSlide} arrow />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InfoCard;
